import { Invoice } from "types/invoice";
import client from "./client";

export const fetchOrgInvoices = async (org_id: string): Promise<Invoice[]> => {
  const params = {
    order: ["invoice_num", "DESC"]
  };
  return client
    .get(`/invoice/organization/${org_id}`, { params })
    .then(response => response.data.response);
};

export const getInvoice = async (invoice_id: string): Promise<Invoice> => {
  return client
    .get(`/invoice/invoice/${invoice_id}`)
    .then(response => response.data.response);
};

export const getPayInvoiceLink = async (
  invoice_id: string
): Promise<string> => {
  return client
    .get(`/invoice/pay/${invoice_id}`)
    .then(response => response.data.response);
};

export const updateInvoice = async ({
  id,
  ...data
}: Partial<Invoice>): Promise<Invoice> => {
  return client
    .post(`/invoice/update/${id}`, { ...data })
    .then(response => response.data.response);
};
